<div
		copoVirtualScroller
		[dataId]="dataId"
		#scroller="copoVirtualScroller"
		(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)"
		class="copo-no-user-select sidenav-content copo-order-tracking-block"
		@routeAnimation
		cdkScrollable>
	<div class="order-tracking-list-title" translate>search.batches</div>
	<div class="order-tracking-grid copo-container">
		<a *ngFor="let batch of scroller.list" class="card-block copo-clickable" [routerLink]="['/order-tracking/batch/card', batch.id]" mat-ripple>
			<div class="order-tracking-list-card-header">
				<span class="order-tracking-list-card-header-title">{{ batch.batchReference }}</span>
				<span class="order-tracking-list-card-header-ton">{{ getBatchWeight(batch) | copoNumber:'weight':'t' }}</span>
			</div>
			<div class="order-tracking-list-card-informations-block">
				<div class="order-tracking-list-card-information-block">
					<span class="order-card-label" translate>{{ getProductLabel() }}</span>
					<span class="order-card-value">{{ getProductName(batch) }}</span>
				</div>
				<div class="order-tracking-list-card-information-block">
					<span class="order-card-label" translate>order-tracking.dimension</span>
					<span class="order-card-value">{{ batch | copoDimension }}</span>
				</div>
			</div>
			<div class="order-tracking-list-card-informations-block">
				<div class="order-tracking-list-card-information-block">
					<span class="order-card-label" translate>{{ getOrderName() }}</span>
					<span class="order-card-value">{{ getOrderValue(batch) }}</span>
				</div>
			</div>
			<div class="order-tracking-batch-list-informations-block order-tracking-batch-list-status">
				<mat-icon *ngIf="getIconStatus(batch)" class="order-tracking-list-card-information-icon" [svgIcon]="getIconStatus(batch)"></mat-icon>
				<span class="order-card-value">{{ getBatchStatusLocation(batch) }}</span>
			</div>
		</a>
		<copo-loading-spinner *ngIf="scroller.loading"></copo-loading-spinner>
		<div translate class="empty-page-text" *ngIf="!scroller.loading && scroller.list.length === 0">order-tracking.no.result</div>
	</div>
</div>